import React from 'react';
import { useDrop } from 'react-dnd';
import { useNavigate } from 'react-router-dom';
import { IKanbanActions, IKanbanColumn } from '../../types/layout/kanban';
import { getBreakpointColumnsClass } from '../../helpers/layout';
import { useKanbanColumn } from '../../hooks/kanban/useKanbanColumn';

export const KanbanColumnItems = {
    card: 'card',
};

interface IKanbanColumnProps extends React.PropsWithChildren<IKanbanColumn> {
    kanbanActions?: IKanbanActions;
}

function KanbanColumn({
    actions, breakpointColumn, children, headerClass, title, id, kanbanActions,
}: IKanbanColumnProps) {
    const { cards, moveCard, onCardDrop } = useKanbanColumn({ column: id, kanbanActions });
    const navigate = useNavigate();

    const [{ handlerId }, drop] = useDrop<{ id: string }, void, {handlerId: any}>(() => ({
        accept: KanbanColumnItems.card,
        collect: (monitor) => ({
            handlerId: monitor.getHandlerId(),
        }),
        hover: (item) => {
            if (cards.length === 0) {
                moveCard(item.id);
            }
        },
        drop: onCardDrop,
    }), [cards]);

    const onPlusClick = () => {
        if (typeof actions?.create === 'string') {
            navigate(actions.create);
        }
    };

    const breakpointColumnsClass = breakpointColumn instanceof Object ? getBreakpointColumnsClass(breakpointColumn) : 'col-12 col-md-6 col-lg-3';
    // const breakpointColumnsClass = 'col-12 col-md-3 col-lg-3 column-wrapper'
    const headerClasses = ['column-header'];

    if (typeof headerClass === 'string') {
        headerClasses.push(headerClass);
    }

    return (
        <div className={`${breakpointColumnsClass} column-wrapper`} ref={drop} data-handler-id={handlerId}>
            <div className="column">
                <div className={headerClasses.join(' ')}>
                    <h3 className="column-title">
                        {title}
                    </h3>
                    {typeof actions?.create === 'string' && (
                        <div className="card-tools">
                            <button className="btn btn-tool" type="button" onClick={onPlusClick}>
                                <i className="fas fa-plus" />
                            </button>
                        </div>
                    )}
                </div>
                <div className="column-body">
                    {children}
                </div>
            </div>
        </div>
    );
}

KanbanColumn.defaultProps = {
    kanbanActions: undefined,
};

export default KanbanColumn;
